<div class="app-shell">
  <aside class="app-shell__rail" aria-label="Main navigation">
    <a class="app-shell__logo" routerLink="/" aria-label="Scryber home">
      <img src="/scryber-logo-lime.png?v=4" alt="" />
    </a>

    <nav class="app-shell__nav">
      @for (item of navItems; track item.route) {
        <a
          class="app-shell__nav-btn"
          [class.app-shell__nav-btn--active]="isActive(item.route)"
          [class.app-shell__nav-btn--visits]="item.icon === 'visits'"
          [class.app-shell__nav-btn--patients]="item.icon === 'patients'"
          [class.app-shell__nav-btn--analytics]="item.icon === 'analytics'"
          [class.app-shell__nav-btn--analyzer]="item.icon === 'analyzer'"
          [class.app-shell__nav-btn--compact-hidden]="item.icon === 'subscription'"
          [routerLink]="item.route"
          [attr.aria-label]="item.label"
          [attr.title]="item.label"
          (click)="onNavClick(item, $event)">
          @switch (item.icon) {
            @case ('visits') {
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                <rect x="3" y="4" width="18" height="18" rx="2" />
                <path d="M16 2v4M8 2v4M3 10h18" />
              </svg>
            }
            @case ('patients') {
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
              </svg>
            }
            @case ('analytics') {
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                <path d="M18 20V10M12 20V4M6 20v-6" />
              </svg>
            }
            @case ('analyzer') {
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
              </svg>
            }
            @case ('subscription') {
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <rect x="1" y="4" width="22" height="16" rx="2" ry="2" />
                <line x1="1" y1="10" x2="23" y2="10" />
              </svg>
            }
          }
          <span class="app-shell__nav-label">{{ item.label }}</span>
        </a>
      }
    </nav>

    <div class="app-shell__rail-end">
      <button
        type="button"
        class="app-shell__mic"
        [class.app-shell__mic--active]="isNewVisitActive()"
        aria-label="New Visit"
        title="New Visit"
        (click)="onNewVisit()">
        <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z" />
          <path d="M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z" />
        </svg>
        <span class="app-shell__nav-label">New Visit</span>
      </button>

      <button
        type="button"
        class="app-shell__nav-btn app-shell__logout"
        aria-label="Log out"
        title="Log out"
        (click)="onLogout()">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
          <polyline points="16 17 21 12 16 7" />
          <line x1="21" y1="12" x2="9" y2="12" />
        </svg>
        <span class="app-shell__nav-label">Log out</span>
      </button>
    </div>
  </aside>

  <main class="app-shell__main">
    <div class="app-shell__content">
      <div class="app-shell__viewport">
        <router-outlet />
      </div>
    </div>
  </main>

  <p-dialog 
    [visible]="!hasSubscription && activeRoute !== '/subscription'" 
    [modal]="true" 
    [closable]="false" 
    [closeOnEscape]="false"
    [draggable]="false"
    [resizable]="false"
    header="Subscription Required"
    styleClass="subscription-modal">
    
    <div class="subscription-modal-content" style="text-align: center; padding: 1rem 0;">
      <p style="margin-bottom: 2rem; font-size: 1.1rem; color: var(--text-color);">
        To use the application and access its features, you need an active Scryber Pro subscription.
      </p>
      
      <div style="display: flex; gap: 1rem; justify-content: center;">
        <button pButton 
          label="Go to Subscription" 
          icon="pi pi-credit-card"
          class="p-button-primary p-button-lg"
          (click)="goToSubscription()">
        </button>
        <button pButton 
          label="Sign Out" 
          icon="pi pi-sign-out"
          class="p-button-outlined p-button-secondary p-button-lg"
          (click)="onLogout()">
        </button>
      </div>
    </div>
  </p-dialog>

  <app-help />

  <p-toast></p-toast>
</div>
